import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid, TextField } from '@mui/material'

const PatientReportForms = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12}>
      <TextField
        label="Patient Care Records"
        value={medPlan?.patientReportForms}
        onChange={(e) => {
          setMedPlan((prev) => ({
            ...prev,
            patientReportForms: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        InputLabelProps={{
          shrink: !!medPlan?.patientReportForms,
        }}
        autoComplete="off"
        name="medplan-patientcarerecords"
        multiline
        minRows={2}
        fullWidth
      />
    </Grid>
  )
}

export default React.memo(PatientReportForms)
